<template>
	<section class="services-section sec-padding pb-60 pb-md-140">
		<div class="container-fluid">
			<div class="sec-title text-center">
				<h2>产品展示</h2>
				<p>新时代、新使命、新种业、新征程，引领中国种业、共创民族复兴！</p>
				<span class="decor"><span class="inner"></span></span>
			</div>
			<div class="row">
				<div class="welcome-wrp col-lg-4 col-md-4 col-sm-4 col-xs-12 p-0">
					<div class="services-wlc">
						<div class="content">
							<h3 class="color-theme title fw-b">高品质产品，让客户无忧</h3>
							<p>公司产品已涵盖水稻、玉米等主要农作物种子的繁殖、生产和加工，实现了种子生产“布局区域化，生产标准化，加工专业化”的规范管理</p>
							<a class="color-light-white font-size-18 fw-b" href="#">查看更多产品 <i class="fa fa-arrow-circle-right"></i></a>
						</div>
					</div>
				</div>
				<div class="col-lg-8 col-md-12 col-sm-12 col-xs-12 p-0">
					<div class="services-content services-carousel pl-30 pl-md-0">
						<div v-for="item in data" class="item">
							<div class="service-box">
								<div class="img-thumb">
									<img :src="item.product_img" alt="">
								</div>
								<div class="content">
									<h4 class="title"><a href="#">{{item.product_name}}</a></h4>
								</div>
								<div class="overlay">
									<p v-html="item.product_intro"></p>
									<a class="btn-link" href="javascript:void(0);" @click="detail(item)">查看详情 <i class="fa fa-arrow-circle-right"></i></a>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</section>
</template>

<script>
	import tmp from "@/assets/js/tmp.js";
	export default {
		name: 'services',
		props: ['data'],
		data(){
			return{
				list: tmp.home.service
			}
		},
		mounted:function() {
			this.initService();
		},
		methods: {
			initService: function() {
				$('.services-carousel').owlCarousel({
		            loop: true,
		            margin: 30,
		            nav: true,
		            dots: false,
		            navText: [
		                '<i class="fa fa-angle-left"></i>',
		                '<i class="fa fa-angle-right"></i>'
		            ],
		            autoplay: true,
		            autoplayTimeout: 3000,
		            autoplayHoverPause: true,
		            responsive: {
		                0: {
		                    items: 1
		                },
		                540: {
		                    items: 2
		                },
		                849: {
		                    items: 3
		                },
		                1110: {
		                    items: 4
		                },
		                1200: {
		                    items: 3
		                },
		                1400: {
		                    items: 3
		                },
		                1626: {
		                    items: 4
		                }
		            }
		        });
			},
			detail(item){
				// let href = window.location.href.split("#")[0];
				// href += "#/productDetail/"+ item.id;
				// window.open(href);
				this.$router.push({
					name: 'productDetail',
					params: {
						id: item.id
					}
				});
			}
		}
	}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/home/Services.vue